const tabs = document.querySelectorAll('.js-price-tabs button');

tabs.forEach(tab => {
    tab.addEventListener('click', () => {
        tabs.forEach(tab => tab.classList.remove('_active'));
        tab.classList.add('_active');

        document.querySelectorAll('.js-price-table').forEach(table => {
            if (table.dataset.filter === tab.dataset.filter) {
                table.classList.add('_active');
            } else {
                table.classList.remove('_active');
            }
        });
    });
});
